import { render, staticRenderFns } from "./UpdateEventCodeModal.vue?vue&type=template&id=28f45020"
import script from "./UpdateEventCodeModal.vue?vue&type=script&lang=js"
export * from "./UpdateEventCodeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports